(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("yjui", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["yjui"] = factory(require("vue"));
	else
		root["yjui"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_4__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition